export default __webpack_public_path__ + "static/media/image404.39497b9c.png";